module.exports = __webpack_public_path__ + "media/images/vp/samples/21-0e88fc2dec642eadb9130fe3108813b9.jpg";